import { Store } from "pullstate";
import { Allowance } from "../global/getAllowances";
import { Amount } from "../../types/amount";
import { Hash } from "viem";
import { TokenFlow } from "../../hooks/allowances/useTokensForApproval";
import { PermitType } from "../../utils/permitUtils";
import { TokenMetadata } from "../global/getTokenMetadata";

export interface ApprovalsStoreSchema {
  initialAllowances: Array<Allowance>;
  currentAllowances: Array<Allowance>;
  tokensToApprove: Array<Allowance & { needed: Amount }>;
  requiredSignatures: Array<Hash>;
  tokensByFlow: {
    approve: Array<TokenFlow>;
    revoke: Array<TokenFlow>;
  };
  permitType: PermitType | undefined;
  tokenMetadata: TokenMetadata;
}

export const ApprovalStore = new Store<ApprovalsStoreSchema>({
  initialAllowances: [],
  currentAllowances: [],
  tokensToApprove: [],
  requiredSignatures: [],
  tokensByFlow: {
    approve: [],
    revoke: [],
  },
  permitType: undefined,
  tokenMetadata: {},
});
